import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ScrollToTop, ErrorBoundary, getCMSObject, TeleScript } from 'sg-ui-components';

import { createStore } from './Store';

import HomePage from './pages/home';
import Feedback from './pages/feedback';
import Promotions from './pages/promotions';
import SecondChancePromotion from './pages/secondChancePromotion';
import MyActivityPage from './pages/myActivity';
import SurveyPage from './pages/survey';
import PostClaimPage from './pages/postClaim';
import WinnersPage from './pages/winners';
import PageNotFound from './pages/404';

import Login from './pages/login';
import LoginPTA from './pages/loginPta';
import RegisterPage from './pages/register';
import Logout from './pages/logout';
import MyProfilePage from './pages/myProfile';
import StorePage from './pages/store';

import EnterPage from './pages/enter';

import PromotionDetailsPage from './pages/promotionDetails';

import Drawings from './pages/drawings';
import pointsForDrawingsDetailsPage from './pages/pointsForDrawingsDetailsPage';

import FaqPage from './pages/faq';
import RulesPage from './pages/rules';
import TermsPage from './pages/terms';
import PrivacyPage from './pages/privacy';
import ContactUsPage from './pages/contactUs';

import ProgressiveJackpotPage from './pages/progressiveJackpot';

import './styling/global.scss';
import SnackbarContainer from './Components/SnackbarContainer';

const app = document.getElementById('root');

const errorBoundaryTelescript = getCMSObject('data.messages.pageErrorMessages.jsonBlock');

render(
    <Provider store={createStore()}>
        <ErrorBoundary fallback={<TeleScript line={errorBoundaryTelescript?.rootFallback} />} details={{}}>
            <Router basename='/'>
                <ScrollToTop />
                <Suspense fallback={<div>Loading...</div>}>
                    <Switch>
                        <Route exact path='/' component={HomePage} />
                        <Route path='/home' component={HomePage} />
                        <Route path='/winners' component={WinnersPage} />
                        <Route path='/promotions' component={Promotions} />
                        <Route path='/drawings' component={Drawings} />
                        <Route path='/second-chance-promotion' component={SecondChancePromotion} />
                        <Route path='/promotion' component={PromotionDetailsPage} />
                        <Route path='/points-for-drawing-details/:sweepId' component={pointsForDrawingsDetailsPage} />
                        <Route path='/survey' component={SurveyPage} />

                        <Route path='/faq' component={FaqPage} />
                        <Route path='/rules' component={RulesPage} />
                        <Route path='/terms' component={TermsPage} />
                        <Route path='/privacy' component={PrivacyPage} />
                        <Route path='/contact-us' component={ContactUsPage} />

                        <Route path='/feedback' component={Feedback} />
                        <Route path='/post-claim' component={PostClaimPage} />
                        <Route path='/my-activity' component={MyActivityPage} />
                        <Route path='/login' component={Login} />
                        <Route path='/login-pta' component={LoginPTA} />
                        <Route path='/register' component={RegisterPage} />
                        <Route path='/my-profile' component={MyProfilePage} />
                        <Route path='/store' component={StorePage} />
                        <Route path='/logout' component={Logout} />
                        <Route path='/enter' component={EnterPage} />

                        <Route path='/progressive-jackpot-test' component={ProgressiveJackpotPage} />

                        <Route path='*' component={PageNotFound} />
                    </Switch>
                    <SnackbarContainer />
                </Suspense>
            </Router>
        </ErrorBoundary>
    </Provider>,
    app
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
